module.exports = __webpack_public_path__ + "img/nigeria.58174f91.svg";